import React, { useEffect, useState } from "react";
import {
  Layout,
  Space,
  PageHeader,
   Table,
    Popconfirm,
    Button,
    Checkbox,
    Modal,
    Input,
    message
} from "antd";
import R2Footer from "../../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Delete from "../../../assets/images/delete_icon.svg";
import { PlusCircleFilled } from "@ant-design/icons";
import KdsStationService from '../../../services/kdsStationService';
import "./styles.scss";
import Edit from "../../../assets/images/edit_icon.svg";


const { Content } = Layout;

const KDSStation = (props) => {
  const [showAdd, setShowAdd] = useState(false);
  const [isUpdate, setIsUpdate] = useState();
  const [stationList, setStationList] = useState([]);
  const [allowExpeditor, setAllowExpeditor] = useState(false);
  const [name, setName] = useState("");

  const getStationDetails = () => {
    KdsStationService.getStationData(props.adminRestaurant).then((resp)=>{
      setStationList(resp);
    });
  };
  const saveCourse = (isUpdate) => {
    if(!name)
    {
      message.error("Enter station name");
      return;
    }
    if(isUpdate){
      const payload ={
        allow_expeditor: allowExpeditor,
        name: name
    }
      KdsStationService.updateStationData(payload,isUpdate?.id).then((res)=>{
        if(res){
          
          getStationDetails();
          setIsUpdate(null);
          setAllowExpeditor(false);
          setName("");
          setShowAdd(false);
          message.success("Updated successfully");
        }
      });
    }
    else if(name) {
      KdsStationService.saveStationData({
          "name" : name,
          "allow_expeditor": allowExpeditor
      }).then((res)=>{
        if(res){
          getStationDetails();
          setAllowExpeditor(false);
          setName("");
          setShowAdd(false);
          message.success("Saved successfully");
        }
      });
    } else {
      message.warning("Enter station name");
    } 
  };
  const deleteStation = (id) =>{
    KdsStationService.deleteStationData(id).then((res)=>{
      if(res){
        getStationDetails();
        message.success("Deleted successfully");
      }
    });
  }

  

  const handleCheckboxChange =(checked, item)=>{

  }

  useEffect(()=>{
    getStationDetails();
  }, []);

  const columns = [
    {
        title: 'Station Name',
        dataIndex: 'name',
        key: 'name',
        width: '40%' 
    },
    {
        title: 'Go Through Expeditor',
        dataIndex: 'allow_expeditor',
        key: 'allow_expeditor',
        width: '45%', 
        render: (_, record) => {
            return <div className="applicable_list">
               <Checkbox checked={record.allow_expeditor}
               />
            </div>
        }
    },
    {
        title: 'Action',
        width: '15%', 
        render: (_, record) => {
            return <div
                style={{
                    display: "flex", width: '150px'}}>
                    <>
                    <img src={Edit} alt="" className="update_action" onClick={(e) => {
                                e.stopPropagation();
                                setName(record?.name) ;
                                setAllowExpeditor(record?.allow_expeditor)
                                setIsUpdate(record);
                                setShowAdd(true)
                               
                            }} /> &nbsp;&nbsp;
                        <Popconfirm title="Sure to delete?" onConfirm={(e) => {
                            e.stopPropagation()
                            deleteStation(record.id)
                        }
                        }>
                        <img src={Delete} alt="" className="update_action" />
                        </Popconfirm>
                    </>
            </div>
        }
    }
];
  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <Space
          direction="vertical"
          style={{
            width: "100%",
          }}
        >
          <PageHeader className="page-header" title="KDS Station Management" style={{ background: "#f0f2f5" }} />
          <div style={{ textAlign: 'end'}}>
            <Button type="text" icon={<PlusCircleFilled/>} danger className="addparties-btn" onClick={()=> {
               setIsUpdate(null);
              setShowAdd(true)
            }}>
            Add Station
            </Button>
          </div>
          <div className="table_section">
            <Table columns={columns} bordered dataSource={stationList} className="customise-table overflow-auto" />
          </div>
          <Modal title={isUpdate? "Update Station":"Add Station"} visible={showAdd} footer={null} onCancel={()=>{setShowAdd(false);
            setIsUpdate(null);
            setAllowExpeditor(false);
            setName("");
          }}>
            <div className="station_txt"><Input placeholder='Enter Station name'  value={name} onChange={(e)=> { setName(e.target.value) }} /></div>
            <div className="station_expeditor">
              <label>Go Through Expeditor</label>
              <Checkbox checked={allowExpeditor} onChange={(e)=> setAllowExpeditor(e.target.checked)} />
            </div>
            <div className='save_course_setting'>
                <Button type='primary' onClick={()=> saveCourse(isUpdate)}>{
                isUpdate? "Update" : "Save"}</Button>
            </div>
        </Modal>
        </Space>
      </Content>
      <R2Footer />
    </Layout>
  );
};

const mapStateToProps = (state) => {
  return {
    adminRestaurant: state.admin,
  };
};
export default withRouter(connect(mapStateToProps)(KDSStation));
